import Grid from '@blocks/Grid'
import { Box, Container } from '@styles/helpers'
import { tablet } from '@styles/mixins'
import { grid } from '@styles/vars'
import React from 'react'
import styled, { css } from 'styled-components'

export default function MainContainer({ heading, children, box = true, tools }: MainContainerProps) {
    return (
        <Wrapper>
            <Grid>
                {(heading || tools) && (
                    <Header>
                        {heading && <h1 className="h4">{heading}</h1>}
                        {tools && <div>{tools}</div>}
                    </Header>
                )}
                {box ? (
                    <Box narrow={true}>
                        {children}
                    </Box>
                ) : children}
            </Grid>
        </Wrapper>
    )
}

// STYLES
const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Wrapper = styled(Container)`
    padding-top: ${grid.margins.phone};
    padding-bottom: ${grid.margins.phone};

    ${tablet(css`
        padding-bottom: ${grid.margins.tablet};
    `)}
`

// TYPES
interface MainContainerProps {
    heading?: React.ReactNode
    children?: React.ReactNode
    tools?: React.ReactNode
    box?: boolean
}